export default __webpack_public_path__ + "static/media/filter.9f39f383.svg";